import { Component, Inject, Prop, Vue, Watch } from "vue-property-decorator";
import { STYLE_CLASSES } from "./../../../../shared/constants/StyleConstants";
import {
  EVENT_VALID_NAME_FIELD,
  ROLE_CONSTANTS
} from "@/modules/Roles/constants/RoleConstants";
import {
  COLLECTIONS_NAME,
  FORM_VALIDATORS
} from "@/shared/constants/FormConstants";
import { STATE } from "@/shared/constants/GeneralConstants";
import { RolesService } from "../../services/RolesService";
import { Utils } from "@/shared/utils/utils";

@Component({
  name: "AdminRolCard"
})
export default class AdminRolCard extends Vue {
  @Inject() rolesService!: RolesService;

  @Prop() private nameRole!: string;
  @Prop() private stateRole!: boolean | string;
  @Prop() isEditing!: boolean;
  cardClass = STYLE_CLASSES.CARD_2;
  ROLE_CONST = ROLE_CONSTANTS.ADMIN_ROL_CARD;
  btnRoundClassPrimary = STYLE_CLASSES.PRIMARY_ROUND_BTN;
  LABEL_STATUS = STATE.ACTIVE;
  card2Class = STYLE_CLASSES.CARD_PADING;
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  switchClass = STYLE_CLASSES.SWITCH;
  rules = {
    name: [
      FORM_VALIDATORS.REQUIRED_FIELD,
      FORM_VALIDATORS.NOT_BLANK_SPACES_VALIDATOR
    ]
  };
  errorsName: string[] = [];

  get stateRoleLocal() {
    return (
      this.stateRole == STATE.ACTIVE ||
      (typeof this.stateRole == "boolean" && this.stateRole)
    );
  }
  set stateRoleLocal(e) {
    this.$emit("update:stateRole", e);
  }
  get nameRoleLocal() {
    return this.nameRole.trim();
  }
  set nameRoleLocal(e) {
    this.$emit("update:nameRole", e.trim());
  }

  async validateUniqueName() {
    this.errorsName = await Utils.checkUniqueName(
      COLLECTIONS_NAME.ROLE,
      this.nameRoleLocal
    );
    this.$emit(EVENT_VALID_NAME_FIELD, !this.errorsName.length);
  }

  @Watch("nameRole", { immediate: true })
  onNameRoleChanged(newVal: string, oldVal: string) {
    if (newVal !== oldVal && !this.isEditing) {
      this.validateUniqueName();
    }
  }
}
